import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { PropertyType } from '../../../shared/models/property-type';
import { AddressService } from '../../services/address.service';
import { Address } from '../../models/address.model';
import { AddressDomainService } from './services/address-domain.service';
import { AddressGeoInfo } from '../../models/address-geo-info.dto';
import { GeoInfoRead } from '../../models/geo-info-read.model';
import { Subscription } from 'rxjs';
import { completeAddressFromAddressAndGeoReadInfo } from '../../services/mappers/address-data.mapper';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
})
export class AddressComponent implements OnChanges, OnInit, OnDestroy {
  @Input() reportId!: string;
  @Input() isLoading = false;

  @Input() addressInput!: string;
  @Input() addressAccuracyLevel!: string | null;
  @Input() addressCity!: string | null;
  @Input() districtName!: string | null;
  @Input() propertyType!: PropertyType;
  @Input() addressType!: string;
  @Output() addressSaved = new EventEmitter<AddressGeoInfo>();

  addressInputAutoCompletion!: Address[];
  autocompleteSelectedAddress: Address | undefined;
  hasAutoCompletionBeenUsed = false;
  geoInfoRead: GeoInfoRead | undefined;
  titleSection = 'Adresse';

  addressInternal!: string;
  cancelModal = false;

  subscribtions = new Subscription();

  constructor(
    private readonly addressService: AddressService,
    private readonly addressDomainService: AddressDomainService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['addressInput']) {
      this.addressInternal = this.addressInput;
    }
    if (changes['reportId']) {
      this.addressDomainService.loadPopupOnFirstReportLoading(
        changes['reportId'],
        this.titleSection,
        this.addressType,
      );
    }
  }

  ngOnInit(): void {
    this.getAutoCompletion();
  }

  ngOnDestroy(): void {
    this.subscribtions.unsubscribe();
  }

  onSaveSection() {
    this.addressSaved.emit(
      completeAddressFromAddressAndGeoReadInfo(
        this.autocompleteSelectedAddress,
        this.geoInfoRead,
        this.addressInternal,
      ),
    );
  }

  onAddressChanged(addressInput: string): void {
    this.autocompleteSelectedAddress = undefined;
    this.geoInfoRead = undefined;
    this.addressInternal = addressInput;
    this.addressService.setAddressInputAutoCompletion(addressInput);
  }

  async onAutocompletionSelected(addressAutocompletion: string) {
    this.addressInternal = addressAutocompletion;
    const address = this.addressDomainService.getAddressFromLabel(
      addressAutocompletion,
      this.addressInputAutoCompletion,
    );
    this.autocompleteSelectedAddress = address;
    this.geoInfoRead =
      await this.addressService.getAddressInputFromAddressDetails(address);
  }

  onCancelModal() {
    this.cancelModal = !this.cancelModal;
  }

  private getAutoCompletion() {
    this.subscribtions.add(
      this.addressService
        .getAddressInputAutoCompletion()
        .subscribe((autoCompletion: Address[]) => {
          this.addressInputAutoCompletion = autoCompletion;
        }),
    );
  }
}
